import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import api from '@/api.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null,
        equipment: null,
        usage: null,
        authorization: {
            app: null,
            user: null
        },
        credential: null,
        intervalSessionApp: null,
        timeoutSessionUser: null,
        signInMessage: null,
    },

    mutations: {
        setUser(state, user) {
            state.user = user
        },
        setEquipment(state, equipment) {
            state.equipment = equipment
        },
        setAuthorizationUser(state, token) {
            state.authorization.user = token
        },
        setAuthorizationApp(state, token) {
            state.authorization.app = token
            state.authorization.app.expires_at =  moment().add(token.expires_in - 300, 'seconds').toDate()
        },
        setCredential(state, credential) {
            state.credential = credential
        },
        setUsage(state, usage) {
            state.usage = usage
        },
        startTimeoutSession(state, router) {
            if (state.timeoutSessionUser) {
                clearTimeout(state.timeoutSessionUser)
            }

            state.timeoutSessionUser = setTimeout(() => {
                state.signInMessage = 'Sessão expirada! Faça o login novamente.'
                router.push('/logout')
            }, 30 * 60 * 1000) //30min
        },
        clearSignInMessage(state) {
            state.signInMessage = null
        },
    },

    actions: {
        setUser(context, action) {
            context.commit('setUser', action)
        },
        requestUserInfo(context) {
            api.userRequest({
                url: `user/me?load=addressCountry`
            }).then(r => {
                context.commit('setUser', r.data)
            }).catch(e => {
                console.log('Erro ao obter informações do usuário!', e)
            })
        },
        startIntervalSessionApp(context) {
            context.state.intervalSessionApp = setInterval(() => {
                context.dispatch('renewAuthorizationApp')
            }, 60 * 60 * 1000) //60min
        },
        renewAuthorizationApp(context) {
            let expired = false

            if (context.state.authorization
                && context.state.authorization.app
                && context.state.authorization.app.expires_at
            ) {
                const now = new Date()
                const expiresAt = new Date(context.state.authorization.app.expires_at)
                expired = now > expiresAt
            }

            console.log('Token do app expirado?', expired)
            if (expired) {
                api.requestAppAccessToken().then(response => {
                    context.commit('setAuthorizationApp', response)
                }).catch(e => {
                    console.log('Falha ao renovar o token do app', e)
                })
            }
        },
    },

    getters: {
        getUser: state => state.user,
        getEquipment: state => state.equipment,
        getUnit: state => state.equipment && state.equipment.place ? state.equipment.place.unit : null,
        getCredential: state => state.credential,
        getUsage: state => state.usage,
        getSignInMessage: state => state.signInMessage,
    }
})